<template>
  <div>
    <div class="question-box-intro-two"><h3>Details</h3></div>
    <PropertyText
        v-model="form.text"
        :index="index"
        :noSave="noSave"
        :errorsPost="errorsPost.text"
        :giftDetails="form"
        :location="location"
        ref="propertyText"
        :id="`${location}${index}text`"
    />

    <PropertyType
        v-model="form.propertyType"
        @input="$refs.propertyText.setText()"
        :errors-post="errorsPost.propertyType"
        :index="index"
        :no-save="noSave"
        :form="form"
        :location="location"
        :id="`${location}${index}propertyType`"
    />


    <PropertyAddress
        v-if="form.propertyType && form.propertyType !== 'custom'"
        v-model="form.address"
        @input="$refs.propertyText.setText()"
        :errors-post="errorsPost.address"
        :no-save="noSave"
        :form="form"
        :location="location"
        :id="`${location}${index}address`"
    />

    <CustomText
        v-if="form.propertyType === 'custom'"
        @input="$refs.propertyText.setText()"
        v-model="form.userCustomText"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.userCustomText"
        :location="location"
        :id="`${location}${index}userCustomText`"
    />
    <PropertyHasMortgageYN
        v-model="form.hasMortgage"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.hasMortgage"
        :location="location"
        :id="`${location}${index}hasMortgage`"
    />
    <PropertyMortgageFreeYN
        v-if="form.hasMortgage"
        v-model="form.mortgageFree"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.mortgageFree"
        :location="location"
        :id="`${location}${index}mortgageFree`"
    />

    <PropertyRestrictToShareYN
        v-model="form.restrictedToShareInterest"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.restrictedToShareInterest"
        :location="location"
        :id="`${location}${index}restrictedToShareInterest`"
    />

    <TaxYN
        v-model="form.taxFree"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.taxFree"
        :location="location"
        :id="`${location}${index}taxFree`"
    />

    <ConditionYN
        v-model="form.conditionYN"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.conditionYN"
        :location="location"
        :id="`${location}${index}conditionYN`"
    />

    <Condition
        v-if="form.conditionYN"
        v-model="form.condition"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.condition"
        :location="location"
        :id="`${location}${index}condition`"
    />

    <Recipients
        v-model="form.recipients"
        :options-data="primaryOptions"
        :index="index"
        :no-save="noSave"
        :location="location"
        :errors-post="errorsPost.recipients"
        :id="`${location}${index}recipients`"
    />

    <ShareType
        v-if="recipientsMoreThanOne"
        v-model="form.shareType"
        :index="index"
        :no-save="noSave"
        :location="location"
        :eachOption="false"
        :gift-details="form"
        typeLocation="shareType"
        :id="`${location}${index}shareType`"
    />

    <ShareSeparatePercentages
        v-if="form.shareType === 'separate'"
        v-model="form.recipients"
        :index="index"
        :no-save="noSave"
        :location="location"
        :gift-details="form"
        shareLocation="recipients"
    />

    <div v-if="showPerStirpesOptions">
      <StirpesYN
          v-model="form.stirpes"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.stirpes"
          :location="location"
          :gift-details="form"
          :id="`${location}${index}stirpes`"
      />
      <StirpesAge
          v-if="form.stirpes"
          v-model="form.stirpesAge"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.stirpesAge"
          :location="location"
          :id="`${location}${index}stirpesAge`"
      />
    </div>

    <div v-show="showBackupOptions">
      <RecipientsBackupYN
          v-model="form.backupRecipientsYN"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.backupRecipientsYN"
          :location="location"
          :gift-details="form"
          :id="`${location}${index}backupRecipientsYN`"
      />

      <RecipientsBackup
          v-if="form.backupRecipientsYN"
          v-model="form.backupRecipients"
          :options-data="secondaryOptions"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          :errors-post="errorsPost.backupRecipients"
          :id="`${location}${index}backupRecipients`"
      />

      <ShareType
          v-if="backupRecipientsMoreThanOne"
          v-model="form.shareTypeBackup"
          :index="index"
          :no-save="noSave"
          :location="location"
          :eachOption="false"
          :gift-details="form"
          typeLocation="shareTypeBackup"
          :id="`${location}${index}shareTypeBackup`"
      />

      <ShareSeparatePercentages
          v-if="form.shareTypeBackup === 'separate'"
          v-model="form.backupRecipients"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          shareLocation="backupRecipients"
      />
    </div>
  </div>
</template>

<script>
import {giftRecipientHelpers} from "../../../question/questions/will/gifts/giftRecipientHelpers";

import ConditionYN from "../../../question/questions/will/gifts/sub/ConditionYN";
import Condition from "../../../question/questions/will/gifts/sub/Condition";
import TaxYN from "../../../question/questions/will/gifts/sub/TaxYN";
import StirpesYN from "../../../question/questions/will/gifts/sub/StirpesYN";
import StirpesAge from "../../../question/questions/will/gifts/sub/StirpesAge";
import Recipients from "../../../question/questions/will/gifts/sub/Recipients";
import RecipientsBackup from "../../../question/questions/will/gifts/sub/RecipientsBackup";
import RecipientsBackupYN from "../../../question/questions/will/gifts/sub/RecipientsBackupYN";
import ShareType from "../../../question/questions/will/gifts/sub/ShareType";
import ShareSeparatePercentages from "../../../question/questions/will/gifts/sub/ShareSeparatePercentages";
import PropertyMortgageFreeYN from "../../../question/questions/will/gifts/sub/PropertyMortgageFreeYN";
import PropertyRestrictToShareYN from "../../../question/questions/will/gifts/sub/PropertyRestrictToShareYN";
import PropertyAddress from "../../../question/questions/will/gifts/sub/PropertyAddress";
import PropertyText from "../../../question/questions/will/gifts/sub/PropertyText";
import PropertyType from "../../../question/questions/will/gifts/sub/PropertyType";
import CustomText from "../../../question/questions/will/gifts/sub/CustomText";
import PropertyHasMortgageYN from "../../../question/questions/will/gifts/sub/PropertyHasMortgageYN";

export default {
  name: 'GiftProperty',
  components: {
    PropertyHasMortgageYN,
    CustomText,
    PropertyType,
    PropertyText,
    PropertyAddress,
    PropertyRestrictToShareYN,
    PropertyMortgageFreeYN,
    ShareSeparatePercentages,
    ShareType,
    RecipientsBackupYN,
    RecipientsBackup,
    Recipients,
    StirpesAge,
    StirpesYN,
    TaxYN,
    Condition,
    ConditionYN
  },
  mixins: [giftRecipientHelpers],
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Object,
      default: () => {
        return {}
      }
    },
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  }
}
</script>
